import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { jobViewAction } from "../../../redux/actions/jobsAction";

export const homeSelectStatus = (jobs, queryParam) => {
  let array = [];
  if (queryParam === 'closed') {
    array = Object.values(jobs).filter((job) => job.closed);
  } else {
    array = Object.values(jobs).filter((job) => job.Status.toString() === queryParam.toString() && !job.closed);
  }
  return array;
};

export const homeSelectTitle = (jobs, queryParam) => {
  let array = [];
  if (queryParam === 'asc') {
    array = jobs.sort((a, b) => {
      return `${a.jobTitle.toLowerCase()}`.localeCompare(b.jobTitle.toLowerCase());
      // a.jobTitle.toLowerCase() - b.jobTitle.toLowerCase()
    });
  }
  if (queryParam === 'des') {
    array = jobs
      .sort((a, b) => {
        return `${a.jobTitle.toLowerCase()}`.localeCompare(b.jobTitle.toLowerCase());
      })
      .reverse();
  }
  if (queryParam === 'desDate') {
    array = jobs.sort((a, b) => a.createdAt - b.createdAt);
  }
  if (queryParam === 'ascDate') {
    array = jobs.sort((a, b) => a.createdAt - b.createdAt).reverse();
  }
  return array;
};

const searchEncargado = (jobs, id) => {
  return jobs.filter((job) => {
    if (job.encargado) {
      if (Object.values(job.encargado || []).filter((e) => e.objectID === id).length > 0) {
        return true;
      }
      return false;
    }
    return false;
  });
};

// eslint-disable-next-line import/prefer-default-export
export const Filtros = () => {
  const dispatch = useDispatch();
  const jobs = useSelector((state) => state.vacancies);

  const [state, setState] = useState({
    selectStatus: 'all',
    selectDate: 'all',
    byUser: 'gral',
    filtros: false,
    jobs: [],
  });

  const onTouchFiltros = () => {
    let temp = JSON.parse(JSON.stringify(jobs));
    const { selectStatus, selectDate, byUser } = state;
    const jobsProps = JSON.parse(JSON.stringify(jobs));

    if (selectStatus === 'all' && selectDate === 'all' && byUser === 'gral') {
      const tempArray =JSON.parse(JSON.stringify(jobsProps)).sort((a, b) => b.Status - a.Status);
      setState((state) => ({
        ...state,
        filtros: false,
        jobs:tempArray ,
      }));
      dispatch(jobViewAction(tempArray))
      return;
    }
    if (byUser !== 'gral') {
      temp = JSON.parse(JSON.stringify(searchEncargado(jobsProps, byUser)));
    }
    if (selectStatus !== 'all') {
      temp = JSON.parse(JSON.stringify(homeSelectStatus(temp, selectStatus)));
    }
    if (selectDate !== 'all') {
      if (Object.values(temp).length > 0) {
        temp = JSON.parse(JSON.stringify(homeSelectTitle(temp, selectDate)));
      } else {
        temp = JSON.parse(JSON.stringify(homeSelectTitle(jobsProps, selectDate)));
      }
    }
    setState((state) => ({
      ...state,
      filtros: true,
      jobs: JSON.parse(JSON.stringify(temp)),
    }));
    dispatch(jobViewAction(temp))
  };

  const handleStatusFilterChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const searchEncargadoFunction = async (event, isFilterSearch = false) => {
    if (isFilterSearch) {
      setState((state) => ({
        ...state,
        byUser: event.value,
      }));
    } else {
      const { value } = event.target;
      await setState((state) => ({
        ...state,
        byUser: value,
      }));
    }
  };

  const reset = async () => {
    setState((state) => ({
      ...state,
      selectStatus: 'all',
      selectDate: 'all',
      byUser: 'gral',
      jobs,
    }));
  };

  const setJobs = async (array) => {
    await setState((state) => ({
      ...state,
      jobs: array,
    }));
  };

  useEffect(() => {
    onTouchFiltros();
  }, [state.selectStatus, state.selectDate, state.byUser, jobs]);

  return {
    state,
    searchEncargadoFunction,
    handleStatusFilterChange,
    setJobs,
    reset,
  };
};
